import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 9 15",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m8.63 9.033c-3.066.214-5.508 2.78-5.65 5.967h-2.958c.095-3.136 1.686-5.882 4.06-7.5-2.374-1.618-3.965-4.364-4.06-7.5h2.957c.143 3.187 2.585 5.753 5.651 5.967z",
  fill: "#c5ab80"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }